(() => {
  document.querySelectorAll('[data-bbc-name-picker]').forEach(async (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const form = root.querySelector('[data-name-filters]');
    const grid = root.querySelector('[data-name-grid]');
    const title = root.querySelector('[data-results-title]');
    const count = root.querySelector('[data-results-count]');
    const status = root.querySelector('[data-results-status]');
    const more = root.querySelector('[data-show-more]');
    if (!form || !grid || !title || !count || !status || !more) return;

    const labels = {
      kind: 'Kind & compassionate', brave: 'Brave & spirited', joyful: 'Joyful & bright',
      wise: 'Wise & thoughtful', peaceful: 'Peaceful & gentle', nature: 'Inspired by nature',
      creative: 'Creative',
    };
    const traditions = {
      hindu: 'Hindu', muslim: 'Muslim', christian: 'Christian', sikh: 'Sikh',
      jain: 'Jain', buddhist: 'Buddhist', parsi: 'Parsi', jewish: 'Jewish',
    };
    let names = [];
    let shown = 0;
    const pageSize = 8;
    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[character]));

    function card(name) {
      const tags = [...name.qualities.map((key) => labels[key] || key), ...name.traditions.map((key) => `${traditions[key] || key} tradition`)];
      const badges = tags.map((label) => `<span>${escapeHtml(label)}</span>`).join('');
      return `<article class="bbc-name-picker__card"><div class="bbc-name-picker__card-top"><span>${escapeHtml(name.origin)}</span></div><h3>${escapeHtml(name.name)}</h3><p class="bbc-name-picker__meaning">${escapeHtml(name.meaning)}</p><div class="bbc-name-picker__tags">${badges}</div></article>`;
    }

    function getResults() {
      const values = new FormData(form);
      const letter = values.get('letter');
      const quality = values.get('quality');
      const tradition = values.get('tradition');
      if (!letter || !quality) return { letter, quality, tradition, results: [] };

      // Letter is the exact filter. Quality and tradition are preference rankings,
      // not hard exclusions, so a complete shortlist remains available for every letter.
      const results = names
        .filter((name) => name.name.toLocaleUpperCase().startsWith(letter))
        .map((name, index) => ({
          name,
          index,
          score: (name.qualities.includes(quality) ? 2 : 0)
            + (tradition && name.traditions.includes(tradition) ? 1 : 0),
        }))
        .sort((a, b) => b.score - a.score || a.index - b.index)
        .map(({ name }) => name);
      return { letter, quality, tradition, results };
    }

    function render() {
      const { letter, quality, tradition, results } = getResults();
      if (!letter || !quality) {
        title.textContent = 'Choose your preferences';
        count.textContent = '';
        status.textContent = 'Select a starting letter and a name quality to see suggestions.';
        grid.innerHTML = '';
        more.hidden = true;
        return;
      }

      shown = Math.min(pageSize, results.length);
      title.textContent = `${letter} names for ${labels[quality].toLowerCase()}`;
      count.textContent = `${results.length} ${results.length === 1 ? 'name' : 'names'}`;
      grid.innerHTML = results.slice(0, shown).map(card).join('');
      status.textContent = results.length
        ? `Names associated with ${labels[quality].toLowerCase()}${tradition ? ` and ${traditions[tradition]} tradition` : ''} appear first. Other ${letter} names are included to give you a useful shortlist.`
        : 'No names are available for this letter yet.';
      more.hidden = results.length <= shown;
    }

    try {
      const response = await fetch(root.dataset.catalogUrl, { credentials: 'same-origin', cache: 'force-cache' });
      if (!response.ok) throw new Error('catalog unavailable');
      const catalog = await response.json();
      names = Array.isArray(catalog.names) ? catalog.names.map((row) => {
        if (!Array.isArray(row) || row.length !== 5) return null;
        const [name, meaning, origin, qualities, traditionList] = row;
        return {
          name, meaning, origin,
          qualities: qualities ? qualities.split(',') : [],
          traditions: traditionList ? traditionList.split(',') : [],
        };
      }).filter(Boolean) : [];
      if (!names.length) throw new Error('catalog empty');

      form.addEventListener('change', render);
      more.addEventListener('click', () => {
        const { results } = getResults();
        shown = Math.min(shown + pageSize, results.length);
        grid.innerHTML = results.slice(0, shown).map(card).join('');
        more.hidden = results.length <= shown;
      });
    } catch {
      form.querySelectorAll('select').forEach((select) => { select.disabled = true; });
      status.textContent = 'The name list could not load right now. Please refresh the page to try again.';
    }
  });
})();
